"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updated_at = exports.created_at = exports.ongoingWorkflowColumn = exports.submissionID = exports.patientID = void 0;
/**
 * Creates a column which will use the CustomExportFunction `patientID`
 *
 * @returns {ColumnSchema} The generated schema.
 */
const patientID = () => ({
    subtitle: 'Aetonix Patient ID',
    func: 'patientId',
});
exports.patientID = patientID;
/**
 * Creates a column which will use the CustomExportFunction `submissionId`
 *
 * @returns {ColumnSchema} The generated schema.
 */
const submissionID = () => ({
    subtitle: 'Aetonix Submission ID',
    func: 'submissionId',
});
exports.submissionID = submissionID;
/**
 * Creates a column which will use the CustomExportFunction `ongoingWorkflow`
 *
 * @returns {ColumnSchema} The generated schema.
 */
const ongoingWorkflowColumn = () => ({
    subtitle: 'Aetonix parent workflow ID',
    func: 'ongoingWorkflow',
});
exports.ongoingWorkflowColumn = ongoingWorkflowColumn;
/**
 * Creates a column which will use the CustomExportFunction `created_at`
 *
 * @returns {ColumnSchema} The generated schema.
 */
const created_at = () => ({
    subtitle: 'Created At',
    func: 'created_at',
});
exports.created_at = created_at;
/**
 * Creates a column which will use the CustomExportFunction `updated_at`
 *
 * @returns {ColumnSchema} The generated schema.
 */
const updated_at = () => ({
    subtitle: 'Updated At',
    func: 'updated_at',
});
exports.updated_at = updated_at;
//# sourceMappingURL=defaultSubsections.js.map